import React from 'react'


function LinkSocialMedia({id, link, srcImg, altImg}) {
  return (
    <div className='container-social flex-center'>
        <a href={link} target='__blanck' rel='noopener noreferrer' className='flex-center'>
            <img id={id} src={srcImg} alt={altImg} width="30" height="30"/>
        </a>
    </div>
  )
}

export default LinkSocialMedia
